import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Interior.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';
import { isReserved } from '../../../../../helper';
import { gaEvent, trackGA } from 'services/ga';

const variants = {
  chernInt: { param: 'chernInt', key: 'chernInt', text: i18n.t('components.header.filtersBar.filters.interior.chernInt'), event: 'Web_List_Filters_Rough' },
  chistInt: { param: 'chistInt', key: 'chistInt', text: i18n.t('components.header.filtersBar.filters.interior.chistInt'), event: 'Web_List_Filters_Finishing' },
  predChistInt: { param: 'predChistInt', key: 'predChistInt', text: i18n.t('components.header.filtersBar.filters.interior.predChistInt'), event: 'Web_List_Filters_Pre_Finishing' },
  remInt: { param: 'remInt', key: 'remInt', text: i18n.t('components.header.filtersBar.filters.interior.remInt'), event: 'Web_List_Filters_Repair' },
  chastRemInt: { param: 'chastRemInt', key: 'chastRemInt', text: i18n.t('components.header.filtersBar.filters.interior.chastRemInt'), event: 'Web_List_Filters_Partial_Repair' },
  whiteBox: { param: 'whiteBox', key: 'whiteBox', text: i18n.t('components.header.filtersBar.filters.interior.whiteBox'), event: 'Web_List_Filters_WhiteBox' },
  repair: { param: 'repair', key: 'repair', text: i18n.t('components.header.filtersBar.filters.interior.repair'), event: 'Web_List_Filters_RMT' }
};

export const parseSearch = (search) => {
  const { interior } = search;

  if (!interior) {
    return { interior: [] };
  }
  const keys = interior.split(',');
  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { interior: keys } = data;
  if (!keys || !keys.length) {
    return { interior: undefined };
  }

  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { interior } = data;
  return { interior: interior.length ? interior : undefined }; // Room
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { interior: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.interior.notSelected');
};

class Interior extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { interior: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile, buildingData } = this.props;
    const { interior: keys } = parseSearch(search);
    const interior = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (interior.includes(key) !== add) {
      if (add) {
        interior.push(key);
      } else {
        interior.splice(interior.indexOf(key), 1);
      }
    }

    const data = { interior };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);

    const variant = variants[Object.keys(variants).find(v => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(gaEvent.buildingChessFilterCheckboxesClick({
      eventContent: [variantName, ` | ${isChecked}`],
      eventContext: mode,
      productType: objectType,
      productName: buildingData.title,
      productID: buildingData.id,
      user_id: profile.id
    }));

    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search } = this.props;
    const { interior } = parseSearch(search);
    const variant = variants[key];

    return (
      this.list.has(key) ?
        <Checkbox
          className={styles.Checkbox}
          innerStyle={styles.FiltersCheckInner}
          classNameClone="CheckboxCloneFilters"
          checked={interior.includes(variant.key)}
          handle={this.handleCheckboxClick.bind(undefined, variant.key)}
          text={variant.text}
        /> : null
    );
  }

  render() {
    const { className, additional, search, chessfilter, cells, t } = this.props;
    const { interior } = parseSearch(search);

    this.list = cells.reduce(
      (list, cell) => (
        cell.data.status === 'saleStatus' ||
        isReserved(cell.data.status) ||
        cell.data.status === 'assignmentStatus'
      )
        ? list.add(cell.data.interior)
        : list,
      (new Set())
    );

    if (!this.list.size) {
      this.list.add('chernInt');
    }

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional }, { [styles.MenuChessfilter]: chessfilter })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.interior.title')}
          {
            !!interior.length &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.interior.clear')}
            </Button>
          }
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('whiteBox')}
            {this.checkbox('predChistInt')}
            {this.checkbox('remInt')}
            {this.checkbox('repair')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('chastRemInt')}
            {this.checkbox('chernInt')}
            {this.checkbox('chistInt')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Interior);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Interior/Interior.js